<template>
  <modal :show="show" title="Add Friend" @close="close">
    <form class="form-grid" @submit.prevent="submit">
      <input type="hidden" class="authenticity-token-postload" name="authenticity_token"/>
      <label>Message</label>
      <textarea v-model="message" :placeholder="default_message"></textarea>
      <input type="submit" :disabled="sent" class="button button-primary" value="Submit"/>
    </form>
  </modal>
</template>

<script>
import Modal from './modal'

export default {
  name: 'new-friend-modal',
  props: ['show', 'userId'],
  emits: ['close'],
  data: function () {
    return {
      message: "",
      sent: false,
      default_message: 'Hi, please accept my friend request.'
    }
  },
  components: {
    'modal': Modal,
  },
  methods: {
    close: function () {
      this.$emit('close')
    },
    submit: function () {
      let message = this.message;
      if (message === "") {
        message = this.default_message;
      }

      this.sent = true;
      axios.post('/account/friend_requests.json', {
        user_id: this.userId,
        message: message,
      }).then(function() {
        Turbo.visit(window.location);
      })
    }
  },
}
</script>
